import { API, api } from "@/lib/api";

async function post(path, body) {
  return fetch(`${API}${path}`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
}

export async function streamPost(path, body, onDelta) {
  let res = await post(path, body);
  if (res.status === 401) {
    await api.post("/auth/refresh").catch(() => {});
    res = await post(path, body);
  }
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(typeof j.detail === "string" ? j.detail : "No se pudo conectar con la IA");
  }
  const meta = { conversacion: res.headers.get("X-Conversacion") };
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.t) onDelta(ev.t);
    }
  }
  return meta;
}
